import { positiveId } from './flagSystem';

export const directionLabel = value => value === null ? 'Not configured' : value;
export const accessPointRouteType = type => typeof type === 'string' ?
  ({ customer: 'Customer', location: 'Location', client: 'Client' }[type.toLowerCase()] || type) : type;

export const accessPointDirectionScope = (point, route) => {
  if (!point || !route || !positiveId(route.typeId)) return null;
  const location = point.location || {};
  const accessPointId = Number(point.id);
  const locationId = Number(point.locationId || location.id);
  const customerId = Number(location.customerId || point.customerId || (point.client && point.client.customerId));
  if (![accessPointId, locationId, customerId].every(positiveId) ||
      (positiveId(location.id) && Number(location.id) !== locationId) ||
      (positiveId(point.customerId) && Number(point.customerId) !== customerId)) return null;
  const routeId = Number(route.typeId);
  const type = accessPointRouteType(route.type);
  if (type === 'Location' && locationId !== routeId) return null;
  if (type === 'Customer' && customerId !== routeId) return null;
  if (type === 'Client' && Number(point.clientId || (point.client && point.client.id)) !== routeId) return null;
  if (!['Location', 'Customer', 'Client'].includes(type)) return null;
  return { customerId, locationId, accessPointId };
};
